export const validation = {
  termsAndConditions: "Please enter Terms and Conditions",
};
